import React from "react";
import tailwindClassnames from "../common/TailwindClassnames";

type Props = {
  stepNumber: number;
  title: string;
  description: string;
  /** Rendered to the right of the title (e.g. the "Requires detection results" chip). */
  titleExtra?: React.ReactNode;
  children: React.ReactNode;
};

/**
 * Numbered stage card shell shared by the three "Choose photos / Detection /
 * Classification" sections on the AI Processing page (AKL-766 redesign).
 */
const StageCard: React.FC<Props> = ({
  stepNumber,
  title,
  description,
  titleExtra,
  children,
}) => (
  <div className={`${tailwindClassnames.formSectionCard} mb-5 text-left`}>
    <div className="flex items-center gap-2.5 mb-1">
      <span
        aria-hidden="true"
        className="w-6 h-6 rounded-full bg-off-white-dark dark:bg-storm-blue-border text-storm-blue dark:text-sky-blue text-xs font-bold flex items-center justify-center flex-none"
      >
        {stepNumber}
      </span>
      <h2 className={tailwindClassnames.formSectionTitle}>{title}</h2>
      {titleExtra}
    </div>
    <p className={`${tailwindClassnames.helperText} mb-2 ml-[34px]`}>
      {description}
    </p>
    <div className="ml-[34px]">{children}</div>
  </div>
);

export default StageCard;
